/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const updateProduitOrganisationSchema = z.object({
      "diffuseurExterneOrganisationId": z.string().describe("Identifiant de l'organisation chez le diffuseur externe")
      })